module.exports = __webpack_public_path__ + "static/media/plusIcon.5ad1c4ff.svg";